import { render, staticRenderFns } from "./group-calssify.vue?vue&type=template&id=d0222e22&scoped=true"
import script from "./group-calssify.vue?vue&type=script&lang=ts"
export * from "./group-calssify.vue?vue&type=script&lang=ts"
import style0 from "./group-calssify.vue?vue&type=style&index=0&id=d0222e22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0222e22",
  null
  
)

export default component.exports